export const DASHBOARD = '/dashboard/' as const
export const DASHBOARD_V2 = '/dashboard/v2/' as const

export const DASHBOARD_STUDENT = `${DASHBOARD}student` as const
export const DASHBOARD_V2_STUDENT = `${DASHBOARD_V2}student` as const
